import React from 'react'

const PaymentOptions = ({ optionsList, selected_option, option_type, handlePaymentSelect }: { optionsList: any, selected_option: any, option_type: any, handlePaymentSelect: (item: any) => void; }) => {
    // @@ check is refrene from saved_card or not
    let isSavedCard = option_type == 'saved_card'
    // console.log(optionsList,"optionsList")
    return (
        <>
            {optionsList?.map((item: any, ind: number) => {
                let value = isSavedCard ? item?.id : item?.value;
                let isChecked = value == selected_option;
                if(isSavedCard && !item?.card?.brand){
                   return;
                }
                // item?.card?.brand
                return (
                    <div
                        key={`${value}-${ind}`}
                        onClick={() => handlePaymentSelect(value)}
                        className={`flex items-center gap-3 border-t py-4 cursor-pointer ${isChecked ? "bga-gray-100 rounded" : ""}`}
                    >
                        <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${isChecked ? "border-black" : "border-gray-400"}`} >
                            {isChecked && (
                                <div className="w-2.5 h-2.5 bg-black rounded-full" />
                            )}
                        </div>
                        {isSavedCard ?
                            <div>
                                <p className="font-medium text-gray-800">
                                    {item?.card?.brand?.charAt(0)?.toUpperCase() + item?.card?.brand?.slice(1)} •••• {item?.card?.last4}
                                </p>
                                <p className="text-sm text-gray-500">Expires {item?.card?.exp_month}/{item?.card?.exp_year}</p>
                            </div> :
                            <span className="text-gray-800 font-medium">{item.label} {item?.label3 && <span className='text-xs'>({" "}{item?.label3}{" "})</span> }</span>}
                    </div>
                );
            })}
        </>
    )
}

export default PaymentOptions